import { render, staticRenderFns } from "./GameOverTeamTag.vue?vue&type=template&id=01f35a2b&"
import script from "./GameOverTeamTag.vue?vue&type=script&lang=js&"
export * from "./GameOverTeamTag.vue?vue&type=script&lang=js&"
import style0 from "./GameOverTeamTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01f35a2b')) {
      api.createRecord('01f35a2b', component.options)
    } else {
      api.reload('01f35a2b', component.options)
    }
    module.hot.accept("./GameOverTeamTag.vue?vue&type=template&id=01f35a2b&", function () {
      api.rerender('01f35a2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/GameOverTeamTag.vue"
export default component.exports